import { DisaggregatedMetric, MetricPanelProps } from "../../services/types";
import { getIndexMetricData, getSortedMetrics, getSvgrMap } from "../../utils/dashboardUtils";
import MetricCard from "../MetricCard";
import IndexBanner from "../IndexBanner";
import MetricBarChart from "../charts/MetricBarChart";
import RaceEthnicityBarChartCard from "../charts/RaceEthnicityBarChartCard";

const DemographicMetrics = ({ indicators, metadata, categorizedData, tab, geoDetails, geoTag, selectionActive }: MetricPanelProps) => {   
    const sortedMetrics = getSortedMetrics(tab, categorizedData);
    console.log("Demographic data:", sortedMetrics);

    let metricsForTab = indicators; // Get metrics for the current tab

    // Find the current tab index metric data and id
    const { indexMetricId, indexMetricData } = getIndexMetricData(tab, metadata, indicators);

    // Exclude the index metric from the list of metrics
    if (indexMetricId) {
        metricsForTab = metricsForTab.filter((metric) => metric.id !== indexMetricId);
    }

    if (!metricsForTab || metricsForTab.length === 0) {
        return <div className="flex items-center justify-center text-color-cai-dashboard">No metrics available for {tab}.</div>;
    }

    // Define metrics for order
    const demoOne: DisaggregatedMetric[] = sortedMetrics[0];
    const demoTwo: DisaggregatedMetric[] = sortedMetrics[1];
    const immigration = indicators.find(i => i.id === 1180);
    const atHomeLanguage = indicators.find(i => i.id === 355);
    const race = indicators.find(i => i.id === 354);
    const ethnicity = indicators.find(i => i.id === 1177);

    return (
        <>
            <div className="mb-2">
                <IndexBanner
                    key={indexMetricId}
                    metric={indexMetricData}
                    svg={undefined}
                    disaggData={indicators}
                    geoDetails={geoDetails}
                    geoTag={geoTag}
                    selectionActive={selectionActive}
                />
            </div>
            
            <p className="text-[10px] text-port-text mx-4">
            Activate the <span aria-hidden="true">🛈</span> <strong>button</strong> to expand additional information about a metric.
            </p>
            <p className="text-port-text mx-4 text-[10px] mb-4">Data updates published February 27, 2026.</p>
            <p className="text-xs text-port-text mx-6">Indicators shown below depict demographic details for the population within the selected area.</p>

            <div className="mx-auto px-4 pb-8 pt-4">
                <div className="grid grid-cols-2 gap-4">
                    {demoOne.map(metric => (
                        <MetricCard
                            key={metric.id}
                            metric={metric}
                            width="w-full"
                            svg={getSvgrMap(metric.id)}
                            disaggData={indicators}
                            geoDetails={geoDetails}
                            geoTag={geoTag}
                            selectionActive={selectionActive}
                        />
                    ))}

                    {/* <div className="col-span-2 w-full">
                        {categorizedData.Demographics.filter(metric => 
                            [getMetricGroupChartId(tab, "raceethnicity")].includes(metric.id) // Race and Ethnicity
                        ).map(metric => (
                            <DisaggregateMetricCard
                                key={metric.id}
                                id={metric.id}
                                title={"Race & Ethnicity"}
                                svg={getSvgMap(metric.id)}
                                disaggData={indicators}
                                geoDetails={geoDetails}
                                geoTag={geoTag}
                                selectionActive={selectionActive}
                            />
                        ))}
                        <RaceEthnicityChart indicators={indicators} title="Race and Ethnicity" tab={tab} chartName="raceethnicity" height="h-72" barColor="#4F92B1" reverseOrder={false} topFive={false}/>
                    </div> */}

                    {race && ethnicity && (
                        <div className="col-span-2 w-full">
                            <RaceEthnicityBarChartCard
                                raceMetric={race}
                                ethnicityMetric={ethnicity}
                                disaggData={indicators}
                                geoDetails={geoDetails}
                                geoTag={geoTag}
                                selectionActive={selectionActive}
                                height="h-60"
                                background="bg-white"
                                barColor={"#4F92B1"}
                            />
                        </div>
                    )}

                    {demoTwo.map(metric => (
                        <MetricCard
                            key={metric.id}
                            metric={metric}
                            width="w-full"
                            svg={getSvgrMap(metric.id)}
                            disaggData={indicators}
                            geoDetails={geoDetails}
                            geoTag={geoTag}
                            selectionActive={selectionActive}
                        />
                    ))}

                    {/* <div className="col-span-2 w-full mb-4">
                        {categorizedData.Demographics.filter(metric => 
                            [getMetricGroupChartId(tab, "immigration")].includes(metric.id) // Top Countries of Immigration
                        ).map(metric => (
                            <DisaggregateMetricCard
                                key={metric.id}
                                id={metric.id}
                                title={metric.name}
                                svg={getSvgMap(metric.id)}
                                disaggData={indicators}
                                geoDetails={geoDetails}
                                geoTag={geoTag}
                                selectionActive={selectionActive}
                            />
                        ))}
                        <SimpleBarChart indicators={indicators} title="Top Countries of Immigration" tab={tab} chartName="immigration" height="h-52" barColor="#4F92B1" bgColor="#F0F0F0" reverseOrder={false} topFive={true}/>
                    </div> */}

                    {immigration && 
                    <div className="w-full mt-2 col-span-2">
                        <MetricBarChart 
                            metric={immigration} 
                            disaggData={indicators}
                            geoDetails={geoDetails}
                            geoTag={geoTag}
                            selectionActive={selectionActive}
                            height="h-40" 
                            background="bg-white"
                            barColor={"#4F92B1"}
                            topFive={true}
                        />
                    </div>
                    }

                    {atHomeLanguage && 
                    <div className="w-full mt-2 col-span-2">
                        <MetricBarChart 
                            metric={atHomeLanguage} 
                            disaggData={indicators}
                            geoDetails={geoDetails}
                            geoTag={geoTag}
                            selectionActive={selectionActive}
                            height="h-40" 
                            background="bg-white"
                            barColor={"#4F92B1"}
                            topFive={true}
                        />
                    </div>
                    }

                    {/* <div className="col-span-2 w-full mb-4">
                        {categorizedData.Demographics.filter(metric => 
                            [getMetricGroupChartId(tab, "homelanguage")].includes(metric.id) // At Home Language
                        ).map(metric => (
                            <DisaggregateMetricCard
                                key={metric.id}
                                id={metric.id}
                                title={"At Home Language"}
                                svg={getSvgMap(metric.id)}
                                disaggData={indicators}
                                geoDetails={geoDetails}
                                geoTag={geoTag}
                                selectionActive={selectionActive}
                            />
                        ))}
                        <SimpleBarChart indicators={indicators} title="At Home Language" tab={tab} chartName="homelanguage" height="h-60" barColor="#4F92B1" bgColor="#F0F0F0" reverseOrder={false} topFive={true}/>
                    </div> */}                    
                </div>
            </div>
        </>
    );
}

export default DemographicMetrics;